import { createSlice } from "@reduxjs/toolkit";
import { apiThunk } from "App/store/apiThunk";

/** Admin-authored CMS pages (privacy policy, terms) shown in the footer modal. */

// Served by the taxi (booking) service, not login, and the route is public.
export const loadPage = apiThunk<any, string>("pageInfo/load", {
  server: "taxi",
  url: (alias) => `pages/static/${alias}`,
  method: "GET",
});

interface PageInfoState {
  pageinfo: any;
  loading: boolean;
}

const initialState: PageInfoState = {
  pageinfo: null,
  loading: false,
};

const pageInfoSlice = createSlice({
  name: "pageinfo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadPage.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadPage.fulfilled, (state, action) => {
        state.pageinfo = action.payload?.data ?? action.payload;
        state.loading = false;
      })
      .addCase(loadPage.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default pageInfoSlice.reducer;
